import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DropdownOption} from "../../../../../models/dropdown-option.model";
import {QuestionnaireConstant} from "../../constants/questionnaire.enum";
import {debounceTime, Subject, takeUntil} from "rxjs";
import {CommonService} from "../../../../shared/services/common.service";
import {MatDialog} from "@angular/material/dialog";
import {Store} from "@ngrx/store";
import {screenType} from "../../../../shared/core/shared.selectors";
import {ActivatedRoute, Router} from "@angular/router";
import {
  EditSurveyDataForSendToRequest,
  FetchClinicsOptionsListRequest,
  FetchGenderOptionsListRequest,
  FetchGroupsOptionsListRequest,
  FetchGroupStatusOptionsListRequest,
  FetchRolesOptionsListRequest,
  FetchScheduleAccordingToListForCreateSurveyRequest,
  FetchSessionListForCreateSurveyRequest,
  FetchSurveyDetailsByIdRequest
} from "../../core/questionnaires.actions";
import {
  FetchClinicListForFilters,
  FetchGenderListForFilters,
  FetchGroupListForFilters,
  FetchGroupStatusListForFilters,
  FetchRolesListForFilters,
  FetchScheduleAccordingToList,
  FetchSurveyDetails,
  SessionDetailsForCreateSurvey
} from "../../core/questionnaires.selectors";
import * as moment from 'moment'
import {roles} from 'src/app/modules/shared/constants/common.constants';

@Component({
  selector: 'app-create-survey-send-to-screen',
  templateUrl: './create-survey-send-to-screen.component.html',
  styleUrls: ['./create-survey-send-to-screen.component.css']
})
export class CreateSurveySendToScreenComponent {
  form: FormGroup = new FormGroup({
    roles: new FormControl([],),
    clientIds: new FormControl([],),
    groupIds: new FormControl([],),
    groupStatus: new FormControl([]),
    gender: new FormControl([]),
    scheduleAccordingTo: new FormControl(''),
    clientSearch: new FormControl(''),
    groupSearch: new FormControl('')
  });

  onlySuperAdminSelected: boolean = false

  groupStatusOptions: DropdownOption[] = []
  groupStatusLoading: boolean = false;

  genderOptions: DropdownOption[] = []
  genderLoading: boolean = false

  rolesOptions: DropdownOption[] = []
  rolesLoading: boolean = false;

  clinicsOptions: DropdownOption[] = []
  clinicsLoading: boolean = false;

  groupsOptions: DropdownOption[] = []
  groupsLoading: boolean = false;

  scheduleAccordingToOptions: DropdownOption[] = []
  scheduleAccordingToLoading: boolean = false;

  sessionDropDownOptions: DropdownOption[] = []
  sessionLoading: boolean = false

  errorMessageMap: any = {
    roles: {},
    clientIds: {},
    groupIds: {},
    groupStatus: {},
    gender: {},
    scheduleAccordingTo: {},
    clientSearch: {},
    groupSearch: {}
  };
  errorMessages: any = {};
  screenType: string = '';
  clientIdAllSelected: boolean = false;
  groupIdAllSelected: boolean = false;

  todaysDate = moment().startOf('day');
  roleMap = roles
  isFirstTimeDataLoadCompleted: boolean = false;
  clinicsHasNext: boolean = false;
  clinicsPageNumber: number = 0
  groupHasNext: boolean = false;
  groupPageNumber: number;
  private mode = QuestionnaireConstant.add;
  private surveyId: string = '';
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private matDialog: MatDialog,
    private store: Store,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(FetchSessionListForCreateSurveyRequest());
    this.store.dispatch(FetchScheduleAccordingToListForCreateSurveyRequest());

    this.store.select(SessionDetailsForCreateSurvey)
      .pipe(takeUntil(this.onDestroy)).subscribe(sessionDetails => {
      this.sessionLoading = sessionDetails.loading;
      this.sessionDropDownOptions = sessionDetails.list
    });

    this.store.select(FetchScheduleAccordingToList)
      .pipe(takeUntil(this.onDestroy)).subscribe(scheduleAccordingToList => {
      this.scheduleAccordingToLoading = scheduleAccordingToList.loading;
      this.scheduleAccordingToOptions = scheduleAccordingToList.list
    })

    this.store.select(screenType).pipe(takeUntil(this.onDestroy))
      .subscribe(screenType => {
        this.screenType = screenType
      });
    this.store.dispatch(FetchRolesOptionsListRequest());
    this.store.dispatch(FetchGroupStatusOptionsListRequest());
    this.store.dispatch(FetchGenderOptionsListRequest())
    this.route.paramMap.pipe(takeUntil(this.onDestroy))
      .subscribe((params: any) => {
        if (params?.params?.questionnaireId) {
          this.surveyId = params?.params?.questionnaireId;
          this.store.dispatch(FetchSurveyDetailsByIdRequest({payload: {surveyId: params?.params?.questionnaireId}}));
        }
        if (!params?.params?.questionnaireId) {
          this.store.dispatch(FetchClinicsOptionsListRequest({
            payload: {pageNumber: 1}
          }));
        }
        if (this.router.url.includes(QuestionnaireConstant.edit)) {
          this.mode = QuestionnaireConstant.edit;
        }
      });

    this.store.select(FetchSurveyDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(formDetails => {
      this.form.patchValue({...formDetails.sendTo, ...formDetails}, {emitEvent: true});

      if (formDetails.scheduleAccordingTo == 1) {
        this.form.patchValue({
          session: formDetails.sendTo.sessionId
        })
      }

      if (formDetails?.sendTo?.clientIds) {
        this.store.dispatch(FetchClinicsOptionsListRequest({
          payload: {pageNumber: 1, shouldInclude: formDetails.sendTo.clientIds}
        }));

        if (formDetails?.sendTo?.clientIds.length > 0) {
          this.store.dispatch(FetchGroupsOptionsListRequest({
            payload: {
              clientId: formDetails?.sendTo?.clientIds,
              pageNumber: 1,
              shouldInclude: formDetails?.sendTo?.groupIds
            }
          }));
        }
        this.isFirstTimeDataLoadCompleted = true;
      }

      if (formDetails.scheduleAccordingTo == 2) {
        const activeFrom = moment(formDetails.activeFrom);
        const activeTo = moment(formDetails.activeTo);
        this.form.patchValue({
          activeFrom:
            moment(activeFrom).isSameOrAfter(this.todaysDate) ? activeFrom : '',
          activeTo:
            moment(activeTo).isSameOrAfter(this.todaysDate) ? activeTo : ''
        })
      }
    });
    this.store.select(FetchRolesListForFilters).pipe(takeUntil(this.onDestroy))
      .subscribe(roles => {
        this.rolesOptions = roles.list;
        this.rolesLoading = roles.loading
      });

    this.store.select(FetchGenderListForFilters).pipe(takeUntil(this.onDestroy))
      .subscribe(gender => {
        this.genderOptions = gender.list;
        this.genderLoading = gender.loading
      });

    this.store.select(FetchClinicListForFilters)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(clinics => {
        this.clinicsOptions = clinics.list;
        this.clinicsLoading = clinics.loading;
        this.clinicsHasNext = clinics.hasNext;
        this.clinicsPageNumber = clinics.pageNumber;
      });

    this.store.select(FetchGroupStatusListForFilters)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(groupStatus => {
        this.groupStatusOptions = groupStatus.list;
        this.groupStatusLoading = groupStatus.loading
      });

    this.form.get('scheduleAccordingTo').valueChanges
      .pipe(takeUntil(this.onDestroy)).subscribe(value => {
      this.addControlAccordingToSelection(value)
    });

    this.form.get('clientIds').valueChanges
      .pipe(debounceTime(1000), takeUntil(this.onDestroy))
      .subscribe((values: number[]) => {
        if (this.isFirstTimeDataLoadCompleted) {
          this.form.patchValue({
            groupIds: []
          });
          this.groupsOptions = [];
        } else {
          this.isFirstTimeDataLoadCompleted = true;
        }

        this.store.dispatch(FetchGroupsOptionsListRequest({
          payload: {
            clientId: values,
            pageNumber: 1,
          }
        }));
      });

    this.store.select(FetchGroupListForFilters)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(group => {
        this.groupsOptions = group.list;
        this.groupsLoading = group.loading;
        this.groupHasNext = group.hasNext;
        this.groupPageNumber = group.pageNumber
      });

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }
        const prevUrlParams = this.commonService.urlParams.getValue();

        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });

    this.form.get('roles').valueChanges.pipe(takeUntil(this.onDestroy))
      .subscribe(role => {
        if (role.length === 1 && role.includes(this.roleMap.superAdmin)) {
          this.onlySuperAdminSelected = true
          this.scheduleAccordingToOptions = this.scheduleAccordingToOptions.map(res => res.key === 1 ? {...res, disabled: true} : {...res});
          this.form.patchValue({
            scheduleAccordingTo: '',
            clientIds: [],
            groupIds: [],
            groupStatus: []
          })
        } else {
          this.onlySuperAdminSelected = false
          this.scheduleAccordingToOptions = this.scheduleAccordingToOptions.map(res => ({...res, disabled: false}))
        }
      })

    this.form.controls['clientSearch'].valueChanges.pipe(takeUntil(this.onDestroy), debounceTime(1000))
      .subscribe(value => {
        this.searchClient();
      })

    this.form.controls['groupSearch'].valueChanges.pipe(takeUntil(this.onDestroy), debounceTime(1000))
      .subscribe(value => {
        this.searchGroup();
      })
  }

  searchClient() {
    this.store.dispatch(FetchClinicsOptionsListRequest({
      payload: {pageNumber: 1, shouldInclude: this.form.value.clientIds, search: this.form.value.clientSearch}
    }));
  }

  searchGroup() {
    this.store.dispatch(FetchGroupsOptionsListRequest({
      payload: {
        pageNumber: 1,
        clientId: this.form.value.clientIds,
        shouldInclude: this.form.value.groupIds,
        search: this.form.value.groupSearch
      }
    }));
  }


  addControlAccordingToSelection(value: string | number) {
    if (!value) {
      if (this.form.get('activeTo') && this.form.get('activeFrom')) {
        this.form.removeControl('activeTo')
        this.form.removeControl('activeFrom')
        const errorMap = {...this.errorMessageMap}
        delete errorMap.activeTo
        delete errorMap.activeFrom
        this.errorMessageMap = {...errorMap}
      }
      if (this.form.get('session')) {
        this.form.removeControl('session');
        const errorMap = {...this.errorMessageMap}
        delete errorMap.session
        this.errorMessageMap = {...errorMap}
      }

    } else {
      if (value === 1) {
        const control: FormControl = new FormControl('', [Validators.required])
        this.errorMessageMap = {
          ...this.errorMessageMap,
          session: {
            required: 'This field is required.',
          },
        }
        if (this.form.get('activeTo') && this.form.get('activeFrom')) {
          this.form.removeControl('activeTo')
          this.form.removeControl('activeFrom')
          const errorMap = {...this.errorMessageMap}
          delete errorMap.activeTo
          delete errorMap.activeFrom
          this.errorMessageMap = {...errorMap}
        }
        this.form.addControl('session', control)
      } else {
        const fromControl: FormControl = new FormControl('', [
          Validators.required,
        ])
        const toControl: FormControl = new FormControl('', [
          Validators.required
        ])
        this.errorMessageMap = {
          ...this.errorMessageMap,
          activeFrom: {
            required: 'This field is required.',
          },
          activeTo: {
            required: 'This field is required.',
          },
        }
        if (this.form.get('session')) {
          this.form.removeControl('session')
          const errorMap = {...this.errorMessageMap}
          delete errorMap.session
          this.errorMessageMap = {...errorMap}
        }
        this.form.addControl('activeFrom', fromControl)
        this.form.addControl('activeTo', toControl);
        this.form.controls['activeFrom'].valueChanges
          .pipe(takeUntil(this.onDestroy))
          .subscribe(value => {
            if (this.form.controls['activeTo'].value && !moment(this.form.controls['activeTo'].value)
              .isSameOrAfter(value)) {
              this.form.patchValue({
                activeTo: null
              }, {emitEvent: false})
            }
          })
      }
    }
  }


  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  saveButtonClicked(navigate: boolean) {
    if (this.form.invalid) {
      this.checkForErrors();
      return
    }
    const formValues = {...this.form.value}
    delete formValues.activeFrom
    delete formValues.activeTo
    delete formValues.scheduleAccordingTo
    delete formValues.session;
    delete formValues.groupSearch;
    delete formValues.clientSearch;
    const payload: any = {
      status: navigate ? QuestionnaireConstant.openStatus : QuestionnaireConstant.draftStatus,
      sendTo: {
        ...formValues,
        clientIds: this.form.value.clientIds.length > 0 ? this.form.value.clientIds : null,
        groupIds: this.form.value.groupIds.length > 0 ? this.form.value.groupIds : null,
        roles: this.form.value.roles ? this.form.value.roles : null,
        groupStatus: this.form.value.groupStatus ? this.form.value.groupStatus : null,
        gender: this.form.value.gender ? this.form.value.gender : null,
        sessionId: this.form.value.session ? this.form.value.session : null,
      },
      scheduleAccordingTo: this.form.value.scheduleAccordingTo ? this.form.value.scheduleAccordingTo : null,
      activeFrom: this.form.value.activeFrom ? this.form.value.activeFrom : null,
      activeTo: this.form.value.activeTo ? this.form.value.activeTo : null
    }
    this.isFirstTimeDataLoadCompleted = false;
    this.store.dispatch(EditSurveyDataForSendToRequest({
      payload: {
        surveyId: this.surveyId,
        ...payload,
        mode: this.mode,
        navigate: navigate
      }
    }))
  }

  backButtonClicked() {
    this.router.navigate([`/stanford-admin/questionnaires/edit/create-questionnaire-form/${this.surveyId}`])
  }

  fetchClinicsNextPageOptions() {
    this.store.dispatch(FetchClinicsOptionsListRequest({payload: {
      pageNumber: this.clinicsPageNumber + 1,
      ...(this.form.value.clientSearch ? {search: this.form.value.clientSearch} : {}),
      ...(this.form.value.clientIds? {shouldInclude: this.form.value.clientIds}:{})
    }}));
  }

  fetchGroupsNextPageOptions() {
    this.store.dispatch(FetchGroupsOptionsListRequest({
      payload: {
        pageNumber: this.groupPageNumber + 1,
        clientId: this.form.value.clientIds,
        ...(this.form.value.groupSearch ? {search: this.form.value.groupSearch} : {}),
        ...(this.form.value.groupIds? {shouldInclude: this.form.value.groupIds}:{})
      }
    }));
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
